// @flow
export const ENQUEUE_SNACKBAR = 'g/snackbar/ENQUEUE';
export const REMOVE_SNACKBAR = 'g/snackbar/REMOVE';

export default {
    ENQUEUE_SNACKBAR,
    REMOVE_SNACKBAR,
};
